import DataTable, { type DataTableColumn } from '../components/DataTable';
import MetricCard from '../components/MetricCard';
import PageHeader from '../components/PageHeader';
import SectionCard from '../components/SectionCard';
import { StatusBadgeFor } from '../components/StatusBadge';
import { recruitmentsByStatus } from '../data/mockHelpers';
import type { JobPosting } from '../data/mock';
import DashboardLayout from '../components/DashboardLayout';
import { dashboardSidebar, dashboardUser, type BusinessPageProps } from './dashboardSidebar';

const jobColumns: DataTableColumn<JobPosting>[] = [
  { key: 'title', header: '职位', cell: (j) => <strong>{j.title}</strong> },
  { key: 'department', header: '部门', cell: (j) => j.department },
  {
    key: 'headcount',
    header: '计划',
    cell: (j) => String(j.headcount),
    align: 'center',
    numeric: true
  },
  {
    key: 'applied',
    header: '简历',
    cell: (j) => String(j.applied),
    align: 'center',
    numeric: true
  },
  {
    key: 'interviewed',
    header: '已面试',
    cell: (j) => String(j.interviewed),
    align: 'center',
    numeric: true
  },
  {
    key: 'offered',
    header: '已发 offer',
    cell: (j) => String(j.offered),
    align: 'center',
    numeric: true
  },
  {
    key: 'status',
    header: '状态',
    cell: (j) => StatusBadgeFor({ status: j.status })
  }
];

function RecruitPage(props: BusinessPageProps) {
  const buckets = recruitmentsByStatus();
  const total = buckets.all.length;
  const applicants = buckets.all.reduce((s, j) => s + j.applied, 0);

  return (
    <DashboardLayout
      sidebar={dashboardSidebar}
      user={dashboardUser}
      pageTitle={{ heading: '招聘管理', sub: '' }}
      metrics={[]}
      chart={{ title: '', data: [], xLabels: [] }}
      quickAccess={[]}
      activeSidebarId="recruit"
      omitPageTitle
      settingsPanel={props.settingsPanel}
      mobileMenu={props.mobileMenu}
      sidebarOpen={props.sidebarOpen}
    >
      <PageHeader
        heading="招聘管理"
        sub={`${total} 个职位 · 累计 ${applicants} 份简历`}
        actions={<button type="button" className="is-primary">新增职位</button>}
      />
      <div className="axi-section">
        <div className="axi-metric-grid">
          <MetricCard label="招聘中" value={String(buckets.open.length)} unit="个" icon="briefcase" />
          <MetricCard label="面试中" value={String(buckets.interviewing.length)} unit="个" icon="users" neutral />
          <MetricCard label="已发 offer" value={String(buckets.offered.length)} unit="个" icon="check" />
          <MetricCard label="已关闭" value={String(buckets.closed.length)} unit="个" icon="document" neutral />
        </div>
      </div>
      <SectionCard
        title="职位漏斗"
        description="按 mock 数据展示当前活跃招聘"
      >
        <DataTable<JobPosting>
          columns={jobColumns}
          rows={buckets.all}
          rowKey={(j) => j.id}
        />
      </SectionCard>
    </DashboardLayout>
  );
}

export default RecruitPage;